<template>
  <div>
    <div class="superuser-gift-card-search__top">
      <validation-observer
        ref="superuserGiftCard"
        tag="form"
        class="superuser-gift-card-search__form"
        @submit.prevent
        @keyup.enter="searchGiftCard()">
        <validation-provider v-slot="{errors}" slim>
          <oie-base-input
            id="query"
            v-model="query"
            label-text="Sök presentkort"
            placeholder="Sista 4 tecken i presentkortskoden"
            :error-messages="errors"
            class="superuser-gift-card-search__input"></oie-base-input>
        </validation-provider>
        <oie-base-button
          v-element-loader="{ endpoint: 'superuser/giftcard/search' }"
          css-classes="button--with-border button--blue superuser-importsearch__action"
          text="Sök"
          @click="searchGiftCard()"></oie-base-button>
      </validation-observer>

      <div>
        <oie-base-button
          v-element-loader="{ endpoint: 'superuser/giftcard/sendToErp' }"
          css-classes="button--with-border button--blue superuser-importsearch__action"
          text="Exportera till ERP"
          @click="exportGiftCards()"></oie-base-button>
      </div>
    </div>

    <div class="superuser-search-result">
      <div v-if="mq('medium')" class="superuser-search-result__head">
        <div class="superuser-gift-card-search-result__cell-title">
          Id
        </div>

        <div class="superuser-gift-card-search-result__cell-title">
          Present kort
        </div>

        <div class="superuser-gift-card-search-result__cell-title">
          Köpt på order nr.
        </div>

        <div class="superuser-gift-card-search-result__cell-title">
          Ursprungligt värde
        </div>

        <div class="superuser-gift-card-search-result__cell-title">
          Kvarvarande belopp
        </div>

        <div class="superuser-gift-card-search-result__cell-title">
          Valuta
        </div>

        <div class="superuser-gift-card-search-result__cell-title">
          Köpt datum
        </div>

        <div class="superuser-gift-card-search-result__cell-title">
          Senaste inlöst datum
        </div>

        <div class="superuser-gift-card-search-result__cell-title">
          Giltligt till
        </div>

        <div class="superuser-gift-card-search-result__cell-title">
          Status
        </div>

        <div class="superuser-gift-card-search-result__cell-title">
          &nbsp;
        </div>
      </div>

      <template v-if="giftCardRows === null">
        <div class="superuser-search-result__body-row superuser-search-result__body-row--message">
          Gör en sökning genom att ange sista 4 tecken i presentkortskoden, kundnummer, epost eller ett ordernummer
        </div>
      </template>

      <template v-else-if="giftCardRows && giftCardRows.length === 0">
        <div class="superuser-search-result__body-row superuser-search-result__body-row--message">
          {{ t('superuserSearchNoHits') }}
        </div>
      </template>

      <div
        v-for="(row, i) in giftCardRows"
        v-else
        :key="row.id"
        v-element-loader="{ endpoint: 'superuser/synccustomer/' + row.id }"
        :class="row.removed ? 'superuser-gift-card-search-result__body-row superuser-gift-card-search-result__body-row_removed' : 'superuser-gift-card-search-result__body-row'">
        <div class="superuser-gift-card-search-result__cell">
          <div v-if="mq('to-medium')">
            Id
          </div>
          {{ row.id }}
        </div>
        <div class="superuser-gift-card-search-result__cell">
          <div v-if="mq('to-medium')">
            Present kort
          </div>
          {{ row.code }}
        </div>
        <div class="superuser-gift-card-search-result__cell">
          <div v-if="mq('to-medium')">
            Köpt på order nr.
          </div>
          {{ row.orderNumber }}
        </div>
        <div class="superuser-gift-card-search-result__cell">
          <div v-if="mq('to-medium')">
            Ursprungligt värde
          </div>
          {{ row.amount }}
        </div>
        <div class="superuser-gift-card-search-result__cell">
          <div v-if="mq('to-medium')">
            Kvarvarande belopp
          </div>
          {{ row.balance }}
        </div>
        <div class="superuser-gift-card-search-result__cell">
          <div v-if="mq('to-medium')">
            Valuta
          </div>
          {{ row.currency }}
        </div>
        <div class="superuser-gift-card-search-result__cell">
          <div v-if="mq('to-medium')">
            Köpt datum
          </div>
          {{ row.createDate }}
        </div>
        <div class="superuser-gift-card-search-result__cell">
          <div v-if="mq('to-medium')">
            Senaste inlöst datum
          </div>
          {{ row.lastUsed }}
        </div>
        <div class="superuser-gift-card-search-result__cell">
          <div v-if="mq('to-medium')">
            Giltligt till
          </div>
          {{ row.validUntil }}
        </div>
        <div class="superuser-gift-card-search-result__cell">
          <div v-if="mq('to-medium')">
            Makulerat
          </div>
          {{ row.status }}
        </div>
        <div v-if="!row.removed" class="superuser-gift-card-search-result__cell superuser-gift-card-search-result__cell--actions">
          <oie-base-button
            css-classes="superuser-search-results__action button--gray"
            text="Ändra"
            @click="openGiftCardDetailsView(row, i)"></oie-base-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import httpService from '@/core/http-service'

export default {
  data: () => ({
    query: null,
    giftCardRows: null
  }),
  computed: {
  },
  mounted() {
  },
  methods: {
    async searchGiftCard() {
      const isValid = await this.$refs.superuserGiftCard.validate()

      if (!isValid) {
        return
      }

      httpService.post('superuser/giftcard/search', { query: this.query, customerNumber: this.customerNumber })
        .then(({ data }) => {
          this.giftCardRows = data
        })
    },
    openGiftCardDetailsView(giftcard, index) {
      this.publish('superuser-edit-gift-card', { giftcard, index })
    },
    async exportGiftCards() {
      httpService.post('superuser/giftcard/sendToErp').then((response) => {
      })
    }
  } }
</script>

<style lang="scss">
.superuser-gift-card-search-result__body-row {
  display: flex;
  flex-wrap: wrap;
}

.superuser-gift-card-search-result__cell {
  flex: 1;
  padding: 6px; /* Adjust as needed */
  box-sizing: border-box;
  overflow: hidden; /* Prevent overflowing content */
}

.superuser-gift-card-search-result__cell-title {
  font-weight: bold;
  flex: 1;
  padding: 8px; /* Adjust as needed */
  box-sizing: border-box;
  overflow: hidden; /* Prevent overflowing content */
}

.superuser-gift-card-search-result__cell--actions {
  flex: 1;
}

.superuser-gift-card-search__top {
  display: flex;
  flex-direction: column;
  margin-bottom: measure(full);

  @include media(medium) {
    flex-direction: row;
  }
}

.superuser-gift-card-search__form {
  display: flex;
  flex-direction: column;
  width: 100%;
  order: 1;

  @include media(small) {
    flex-direction: row;
    max-width: 40rem;
  }

  @include media(medium) {
    order: initial;
  }
}

.superuser-gift-card-search__input,
.superuser-gift-card-search__input-wide {
  min-width: 10rem;
  max-width: 20rem;
  margin-bottom: measure(quarter);

  @include media(small) {
    margin-bottom: 0;
    margin-right: measure(half);
  }
}
</style>
